"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoMapHeader = void 0;
const mobx_1 = require("mobx");
class AutoMapHeader {
    constructor(databaseColumnsHeader) {
        this.databaseColumnsHeader = [];
        this.mapChiroTouch = () => {
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            const headersToMap = ["Time", "Patient", "Provider"];
            const headersToMapLowerCased = headersToMap.map((h) => h.replace(/\s+/g, "").toLowerCase());
            [...importHeaders].forEach((header) => {
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase();
                if (headersToMapLowerCased.includes(headerTextParsed)) {
                    let index = null;
                    switch (headerTextParsed) {
                        case "time":
                            index = databaseColumnsHeaderParsed.indexOf("time");
                            break;
                        case "patient":
                            index = databaseColumnsHeaderParsed.indexOf("patient_full_name");
                            break;
                        case "provider":
                            index = databaseColumnsHeaderParsed.indexOf("provider_full_name");
                            break;
                        default:
                            break;
                    }
                    if (index !== null) {
                        const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                        dropArea.appendChild(header);
                    }
                }
            });
        };
        this.mapEclipse = () => {
            // console.log("asdf");
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            const headersToMap = ["Time", "Patient"];
            const headersToMapLowerCased = headersToMap.map((h) => h.replace(/\s+/g, "").toLowerCase());
            [...importHeaders].forEach((header) => {
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase();
                if (headersToMapLowerCased.includes(headerTextParsed)) {
                    let index = null;
                    switch (headerTextParsed) {
                        case "time":
                            // console.log("index of time", index);
                            index = databaseColumnsHeaderParsed.indexOf("time");
                            break;
                        case "patient":
                            // console.log("index of time", index);
                            index = databaseColumnsHeaderParsed.indexOf("patient_full_nam");
                            break;
                        default:
                            break;
                    }
                    if (index !== null) {
                        const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                        dropArea.appendChild(header);
                    }
                }
            });
        };
        this.mapVericle = () => {
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            const headersToMap = ["Appt Time", "Patient", "Date", "Physician"];
            const headersToMapLowerCased = headersToMap.map((h) => h.replace(/\s+/g, "").toLowerCase());
            [...importHeaders].forEach((header) => {
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase();
                if (headersToMapLowerCased.includes(headerTextParsed)) {
                    let index = null;
                    switch (headerTextParsed) {
                        case "appttime":
                            index = databaseColumnsHeaderParsed.indexOf("time");
                            break;
                        case "patient":
                            index = databaseColumnsHeaderParsed.indexOf("patient_full_name");
                            break;
                        case "date":
                            index = databaseColumnsHeaderParsed.indexOf("date");
                            break;
                        case "physician":
                            index = databaseColumnsHeaderParsed.indexOf("provider_full_name");
                            break;
                        default:
                            break;
                    }
                    if (index !== null) {
                        const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                        dropArea.appendChild(header);
                    }
                }
            });
        };
        this.mapNexgenHealthFusion = () => {
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            const headersToMap = ["Date", "Patient Name", "Date of Birth"];
            const headersToMapLowerCased = headersToMap.map((h) => h.replace(/\s+/g, "").toLowerCase());
            [...importHeaders].forEach((header) => {
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase();
                if (headersToMapLowerCased.includes(headerTextParsed)) {
                    let index = null;
                    switch (headerTextParsed) {
                        case "date":
                            index = databaseColumnsHeaderParsed.indexOf("date");
                            break;
                        case "patientname":
                            index = databaseColumnsHeaderParsed.indexOf("patient_full_name");
                            break;
                        case "dateofbirth":
                            index = databaseColumnsHeaderParsed.indexOf("patient_dob");
                            break;
                        default:
                            break;
                    }
                    if (index !== null) {
                        const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                        dropArea.appendChild(header);
                    }
                }
            });
        };
        this.mapAdvancedMD = () => {
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            const headersToMap = ["Name", "DOB", "Zip", "Gender", "Provider"];
            const headersToMapLowerCased = headersToMap.map((h) => h.replace(/\s+/g, "").toLowerCase());
            [...importHeaders].forEach((header) => {
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase();
                if (headersToMapLowerCased.includes(headerTextParsed)) {
                    let index = null;
                    switch (headerTextParsed) {
                        case "name":
                            index = databaseColumnsHeaderParsed.indexOf("patient_full_name");
                            break;
                        case "dob":
                            index = databaseColumnsHeaderParsed.indexOf("patient_dob");
                            break;
                        case "zip":
                            index = databaseColumnsHeaderParsed.indexOf("patient_zip");
                            break;
                        case "gender":
                            index = databaseColumnsHeaderParsed.indexOf("patient_gender");
                            break;
                        case "provider":
                            index = databaseColumnsHeaderParsed.indexOf("provider_full_name");
                            break;
                        default:
                            break;
                    }
                    if (index !== null) {
                        const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                        dropArea.appendChild(header);
                    }
                }
            });
        };
        this.mapMeditouch = () => {
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            const headersToMap = [
                "Date of Service",
                "Time",
                "Patient Name",
                "Date of Birth",
                "Gender"
            ];
            const headersToMapLowerCased = headersToMap.map((h) => h.replace(/\s+/g, "").toLowerCase());
            [...importHeaders].forEach((header) => {
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase();
                if (headersToMapLowerCased.includes(headerTextParsed)) {
                    let index = null;
                    switch (headerTextParsed) {
                        case "dateofservice":
                            index = databaseColumnsHeaderParsed.indexOf("date");
                            break;
                        case "time":
                            index = databaseColumnsHeaderParsed.indexOf("time");
                            break;
                        case "patientname":
                            index = databaseColumnsHeaderParsed.indexOf("patient_full_name");
                            break;
                        case "dateofbirth":
                            index = databaseColumnsHeaderParsed.indexOf("patient_dob");
                            break;
                        case "gender":
                            index = databaseColumnsHeaderParsed.indexOf("patient_gender");
                            break;
                        default:
                            break;
                    }
                    if (index !== null) {
                        const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                        dropArea.appendChild(header);
                    }
                }
            });
        };
        this.mapPracticeSuite = () => {
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            const headersToMap = [
                "Patient",
                "Appointment Date",
                "Appointment Time",
                "Rendering Provider"
            ];
            const headersToMapLowerCased = headersToMap.map((h) => h.replace(/\s+/g, "").toLowerCase());
            [...importHeaders].forEach((header) => {
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase();
                if (headersToMapLowerCased.includes(headerTextParsed)) {
                    let index = null;
                    switch (headerTextParsed) {
                        case "patient":
                            index = databaseColumnsHeaderParsed.indexOf("patient_full_name");
                            break;
                        case "appointmentdate":
                            index = databaseColumnsHeaderParsed.indexOf("date");
                            break;
                        case "appointmenttime":
                            index = databaseColumnsHeaderParsed.indexOf("time");
                            break;
                        case "renderingprovider":
                            index = databaseColumnsHeaderParsed.indexOf("provider_full_name");
                            break;
                        default:
                            break;
                    }
                    if (index !== null) {
                        const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                        dropArea.appendChild(header);
                    }
                }
            });
        };
        this.mapBillingVision = () => {
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            const headersToMap = ["__EMPTY"];
            const headersToMapLowerCased = headersToMap.map((h) => h.replace(/\s+/g, "").toLowerCase());
            [...importHeaders].forEach((header) => {
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase();
                if (headersToMapLowerCased.includes(headerTextParsed)) {
                    let index = null;
                    switch (headerTextParsed) {
                        case "__empty":
                            index = databaseColumnsHeaderParsed.indexOf("patient_full_name");
                            break;
                        default:
                            break;
                    }
                    if (index !== null) {
                        const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                        dropArea.appendChild(header);
                    }
                }
            });
        };
        this.mapBillingPrecision = () => {
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            const headersToMap = ["__EMPTY"];
            const headersToMapLowerCased = headersToMap.map((h) => h.replace(/\s+/g, "").toLowerCase());
            [...importHeaders].forEach((header) => {
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase();
                if (headersToMapLowerCased.includes(headerTextParsed)) {
                    let index = null;
                    switch (headerTextParsed) {
                        case "__empty":
                            index = databaseColumnsHeaderParsed.indexOf("patient_full_name");
                            break;
                        default:
                            break;
                    }
                    if (index !== null) {
                        const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                        dropArea.appendChild(header);
                    }
                }
            });
        };
        this.mapMedisoft = () => {
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            const headersToMap = [];
            const headersToMapLowerCased = headersToMap.map((h) => h.replace(/\s+/g, "").toLowerCase());
            [...importHeaders].forEach((header) => {
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase();
                if (headersToMapLowerCased.includes(headerTextParsed)) {
                    let index = null;
                    switch (headerTextParsed) {
                        case "testtesttesttest":
                            index = databaseColumnsHeaderParsed.indexOf("date");
                            break;
                        default:
                            break;
                    }
                    if (index !== null) {
                        const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                        dropArea.appendChild(header);
                    }
                }
            });
        };
        this.mapMacPractice = () => {
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            const headersToMap = [
                "Patient Last, First",
                "Date of Birth",
                "Date",
                "Provider"
            ];
            const headersToMapLowerCased = headersToMap.map((h) => h.replace(/\s+/g, "").toLowerCase());
            [...importHeaders].forEach((header) => {
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase()
                    .trim();
                // console.log("headerToMapLowerCased", headersToMapLowerCased);
                if (headersToMapLowerCased.includes(headerTextParsed)) {
                    let index = null;
                    // console.log("headerTextParsed ", headerTextParsed);
                    switch (headerTextParsed) {
                        case "patientlast,first":
                            index = databaseColumnsHeaderParsed.indexOf("patient_full_name");
                            // console.log("index in patientlast,first is ", index);
                            break;
                        case "dateofbirth":
                            index = databaseColumnsHeaderParsed.indexOf("patient_dob");
                            break;
                        case "date":
                            index = databaseColumnsHeaderParsed.indexOf("date_time");
                            break;
                        case "provider":
                            index = databaseColumnsHeaderParsed.indexOf("provider_full_name");
                            break;
                        default:
                            break;
                    }
                    if (index !== null) {
                        // console.log("index is ", index);
                        // console.log("headertextparsed is ", headerTextParsed);
                        const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                        dropArea.appendChild(header);
                    }
                }
            });
        };
        this.databaseColumnsHeader = databaseColumnsHeader;
    }
}
__decorate([
    mobx_1.observable
], AutoMapHeader.prototype, "databaseColumnsHeader", void 0);
__decorate([
    mobx_1.action
], AutoMapHeader.prototype, "mapChiroTouch", void 0);
__decorate([
    mobx_1.action
], AutoMapHeader.prototype, "mapEclipse", void 0);
__decorate([
    mobx_1.action
], AutoMapHeader.prototype, "mapVericle", void 0);
__decorate([
    mobx_1.action
], AutoMapHeader.prototype, "mapNexgenHealthFusion", void 0);
__decorate([
    mobx_1.action
], AutoMapHeader.prototype, "mapAdvancedMD", void 0);
__decorate([
    mobx_1.action
], AutoMapHeader.prototype, "mapMeditouch", void 0);
__decorate([
    mobx_1.action
], AutoMapHeader.prototype, "mapPracticeSuite", void 0);
__decorate([
    mobx_1.action
], AutoMapHeader.prototype, "mapBillingVision", void 0);
__decorate([
    mobx_1.action
], AutoMapHeader.prototype, "mapBillingPrecision", void 0);
__decorate([
    mobx_1.action
], AutoMapHeader.prototype, "mapMedisoft", void 0);
__decorate([
    mobx_1.action
], AutoMapHeader.prototype, "mapMacPractice", void 0);
exports.AutoMapHeader = AutoMapHeader;
// export const autoMapHeader = new AutoMapHeader();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-submit-map-header/auto-map-header/auto-map-header.ts
// module id = 3787
// module chunks = 0